import { useContext, useEffect, useState } from "react";
import { MatchTask } from "../../constants/AllTypes";
import { MatchStyles as styles } from "../../css/styles";
import { incorrectIcon, correctIcon } from '../../constants/icons';
import { AuthContext } from "../../context/AuthContext";
import { LessonContext } from "../../context/LessonContext";
import { saveHomeworkState, loadHomeworkState, clearHomeworkState } from '../../utils/homeworkStorage';
import { fetchImage } from "../../utils/functions";
import classNames from "classnames";
import Taskbar from "../Taskbar";
import { useLessonData } from "../../hooks/useLessonData";
import { useTestTasks } from "../../hooks/useTestTasks";
import { useTestProgress } from "../../hooks/useTestProgress";
import { useSendHomework } from "../../hooks/useSendHomework";
import CoinAnimation from "../CoinAnimation";



// interface MatchProps {
//     task: MatchTask;
//     isFullscreen: boolean;
// }

// type Pairs = {
//     aWord: string;
//     aId: string;
//     bWord: string;
//     bId: string;
//     image?: string;
// }

// type BGroup = {
//     bWord: string;
//     bId: string;
// }

// type SubmitData = {
//     matchedPairs: Pairs[];
//     bGroup: BGroup[];
// };

// export const Match: React.FC<MatchProps> = ({ task, isFullscreen }) => {
//     const [pairs, setPairs] = useState<Pairs[]>([]);
//     const [matchedPairs, setMatchedPairs] = useState<Pairs[]>([]);
//     const [originalPairs, setOriginalPairs] = useState<Pairs[]>([]);
//     const [bGroup, setBGroup] = useState<BGroup[]>([]);
//     const [originalBGroup, setOriginalBGroup] = useState<BGroup[]>([]);
//     const [bSelected, setBSelected] = useState<BGroup | null>(null);
//     const [checked, setChecked] = useState(false);
//     const { currentUser } = useContext(AuthContext);
//     const { currentLesson, currentTaskIndex, checkingResult, studentId, currentTestAttempt } = useContext(LessonContext);
//     const taskId = Number(task?.taskId)
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const [fetchedImages, setFetchedImages] = useState<{ [key: string]: string | null }>({});
//     const [isMatching, setIsMatching] = useState(false)
//     const { t } = useTranslation();
//     const [errMsg, setErrMsg] = useState<string | null>(null);
//     const { sendHomework, coinAnimationData } = useSendHomework();
//     const displayVertically = task.taskSettings?.displayVertically
//     const [coinAnimationFinished, setCoinAnimationFinished] = useState(false);
//     const [coinAnimationReady, setCoinAnimationReady] = useState(false);

//     const {data: lessonData} = useLessonData(Number(currentLesson?.lessonId))
//     const lessonPlanParts = lessonData?.lessonPlanParts || []

//     const { data: testTasks } = useTestTasks(Number(currentLesson?.lessonId), Number(studentId), currentTestAttempt, checkingResult);
//     const { testProgress, updateTaskProgress } = useTestProgress(Boolean(currentLesson?.isTest), Number(currentLesson?.lessonId), currentTestAttempt);

//     // LOADING FUNCTIONS
  
//     useEffect(() => {
//         const fetchAllImages = async () => {
//             if (!pairs || pairs.length === 0) return;

//             const newFetchedImages = { ...fetchedImages };

//             for (const pair of pairs) {
//                 if (pair.image && !newFetchedImages[pair.image]) {
//                     const imageUrl = await fetchImage(pair.image);
//                     newFetchedImages[pair.image] = imageUrl;
//                 }
//             }

//             setFetchedImages(newFetchedImages);
//         };

//         fetchAllImages();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [pairs]);

    
    // useEffect(() => {
    //     if (task.taskContent?.pairs) {
    //         // Initialize pairs and matchedPairs with A words and B words
    //         const newPairs = task.taskContent.pairs.map((pair, index) => ({
    //             aWord: pair.A,
    //             aId: index.toString(),
    //             bWord: pair.B,
    //             bId: index.toString(),
    //             image: pair.image,
    //         }));
    //         setPairs(newPairs);


//             // Initialize matchedPairs with only A words
//             const newMatchedPairs = task.taskContent.pairs.map((pair, index) => ({
//                 aWord: pair.A,
//                 aId: index.toString(),
//                 bWord: '',
//                 bId: '',
//                 image: pair.image,
//             }));
//             setMatchedPairs(newMatchedPairs);
//             setOriginalPairs(newMatchedPairs)

//             // Initialize bGroup with B words
//             const newBGroup = [...newPairs].map(pair => ({
//                 bWord: pair.bWord,
//                 bId: pair.bId,  // keep bId as a string
//             }));
//             newBGroup.sort(() => Math.random() - 0.5);
//             setBGroup(newBGroup);
//             setOriginalBGroup(newBGroup)
//         }
//         // if (task.isHomework) {
//         //     setIsHomework(task.isHomework);
//         // }
//         if (checkingResult) {
//             setChecked(true);
//             //homework result
//             if (task.submit) {
//                 // setMatchedPairs(JSON.parse(task.submit));
//                 const progressData = JSON.parse(task.submit)
//                 setMatchedPairs(progressData.matchedPairs || []);
//                 setBGroup(progressData.bGroup || []);

//             //test results
            // } else if (testTasks) {
            //     const testTask = testTasks.find((t) => t.taskId === Number(task.taskId));
            //     // submittedAnswers = testTasks.find(testTask => testTask.taskId === taskId)?.submit as Pairs[] ?? null;
            //     if (testTask?.submit === null) {
            //         return
            //     }
            //     let parsedSubmit = testTask?.submit as SubmitData || { matchedPairs: [], bGroup: [] };
            //     setMatchedPairs(parsedSubmit.matchedPairs || [])
            //     setBGroup(parsedSubmit.bGroup || [])


            //     // {submittedAnswers && setMatchedPairs(submittedAnswers)}
            // } else {
//                 setErrMsg(t(`taskErrors.submissionNotFound`))
//             }
//         }
       
//         //test progress
//         if (currentLesson?.isTest && testProgress && testProgress?.[Number(task.taskId)] && testProgress?.[Number(task.taskId)].submit !== null) {
//             const progressData = testProgress[Number(task.taskId)].submit;
//             setMatchedPairs(progressData.matchedPairs || []);
//             setBGroup(progressData.bGroup || []);
//         }
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [task]);

//     // Longest bWord
//     const maxBWordLength = Math.max(...bGroup.map(b => b.bWord.length), 0);
 
//     //Minimum size + padding
//     const minCh = 8;
//     const bWordWidthCh = Math.max(maxBWordLength, minCh);

//     // FUNCTIONS

//     const handleBClick = (b: BGroup) => {
//         if (isMatching) {
//             setIsMatching(false)
//             setBSelected(null)
//             return
//         } else {
//             setIsMatching(true)
//         }
        
//         if (checkingResult) return;
//         setBSelected(prevB => {
//             // If the clicked B word is the same as the currently selected B word, deselect it
//             if (prevB && prevB.bId === b.bId) {
//                 return null;
//             }
//             // Otherwise, select the clicked B word
//             return b;
//         });
//     };

//     const handleBoxClick = (index: number) => {
//         if (checkingResult) return;
//         // Only proceed if a B word is selected
//         if (bSelected) {
//             setMatchedPairs(prevPairs => {
//                 const newPairs = [...prevPairs];
//                 const pair = newPairs[index];

//                 // Check if the selected box in matchedPairs is empty
//                 if (!pair.bId) {
//                     // Check if selectedB's bId is currently in bGroup
//                     const bIndex = bGroup.findIndex(b => b.bId === bSelected.bId);
//                     if (bIndex !== -1) {
//                         // Remove this entry from bGroup
//                         setBGroup(prevBGroup => prevBGroup.filter(b => b.bId !== bSelected.bId));
//                     } else {
//                         // If selectedB's bId is not in bGroup, it means it's in one of the boxes
//                         // Find the box that contains the selected word and remove the word from that box
//                         const boxIndex = newPairs.findIndex(p => p.bId === bSelected.bId);
//                         if (boxIndex !== -1) {
//                             newPairs[boxIndex] = { ...newPairs[boxIndex], bWord: '', bId: '' };
//                         }
//                     }
//                     // Place selectedB's bWord and bId at the index of the current selection of matchedPairs
//                     newPairs[index] = { ...pair, bWord: bSelected.bWord, bId: bSelected.bId };
//                     // Deselect B word
//                     setBSelected(null);
//                 } else {
//                     // If bId at the index chosen of matchedPairs is not empty
//                     // Check if selectedB's bId is currently in bGroup
//                     const bIndex = bGroup.findIndex(b => b.bId === bSelected.bId);
//                     if (bIndex !== -1) {
//                         // Remove this entry from bGroup
//                         setBGroup(prevBGroup => {
//                             const newBGroup = prevBGroup.filter(b => b.bId !== bSelected.bId);
//                             // Add the existing bWord and bId from the box back to bGroup
//                             // Only if it doesn't already exist in bGroup
//                             if (!newBGroup.find(b => b.bId === pair.bId)) {
//                                 newBGroup.push({ bWord: pair.bWord, bId: pair.bId });
//                             }
//                             return newBGroup;
//                         });
//                         // Place selectedB's data at the current chosen index in matchedPairs
//                         newPairs[index] = { ...pair, bWord: bSelected.bWord, bId: bSelected.bId };
//                         // Deselect B word
//                         setBSelected(null);
//                     } else {
//                         // If selectedB's bId is not in bGroup, it means it's in one of the boxes
//                         // Find the box that contains the selected word
//                         const boxIndex = newPairs.findIndex(p => p.bId === bSelected.bId);
//                         if (boxIndex !== -1) {
//                             // Swap the selected word with the word that's already in the box
//                             const tempBWord = newPairs[boxIndex].bWord;
//                             const tempBId = newPairs[boxIndex].bId;
//                             newPairs[boxIndex].bWord = newPairs[index].bWord;
//                             newPairs[boxIndex].bId = newPairs[index].bId;
//                             newPairs[index].bWord = tempBWord;
//                             newPairs[index].bId = tempBId;
//                             // Deselect B word
//                             setBSelected(null);
//                         }
//                     }
//                 }

//                 return newPairs;
//             });
//             setIsMatching(false)
//         }
//     };

//     const handleClear = () => {
//         setIsMatching(false)
//         setChecked(false)
//         setIsSubmitted(false)
//         setBGroup(originalBGroup)
//         setMatchedPairs(originalPairs)
//     }

//     const handleShowSingleAnswer = () => {
//         const nextIndex = matchedPairs.findIndex(pair => pair.bWord === "" || pair.aId !== pair.bId);
//         if (nextIndex === -1) return;

//         const aId = matchedPairs[nextIndex].aId;
//         const correctAnswerInBGroup = bGroup.find(b => b.bId === aId);
//         const correctAnswerInMatchedPairs = matchedPairs.find(p => p.bId === aId && p.bWord !== "");

//         const currentBWord = matchedPairs[nextIndex].bWord;

//         // If the correct answer is found in bGroup
//         if (correctAnswerInBGroup) {
//             const updatedPairs = [...matchedPairs];
//             updatedPairs[nextIndex] = {
//                 ...updatedPairs[nextIndex],
//                 bWord: correctAnswerInBGroup.bWord,
//                 bId: correctAnswerInBGroup.bId
//             };

//             // Remove the correct answer from bGroup
//             setBGroup((prevBGroup) => prevBGroup.filter(b => b.bId !== correctAnswerInBGroup!.bId));

//             // Update matchedPairs
//             setMatchedPairs(updatedPairs);

//             // If there was an incorrect bWord at nextIndex, add it back to bGroup
//             if (currentBWord && currentBWord !== correctAnswerInBGroup.bWord) {
//                 setBGroup(prevBGroup => [...prevBGroup, { bWord: currentBWord, bId: matchedPairs[nextIndex].bId }]);
//             }
//         }
//         // If the correct answer is already in matchedPairs
//         else if (correctAnswerInMatchedPairs) {
//             const updatedPairs = [...matchedPairs];

//             // Move correct answer to the correct position (nextIndex)
//             updatedPairs[nextIndex] = {
//                 ...updatedPairs[nextIndex],
//                 bWord: correctAnswerInMatchedPairs.bWord,
//                 bId: correctAnswerInMatchedPairs.bId
//             };

//             // Find and clear the incorrect bWord from its original position
//             const incorrectIndex = matchedPairs.findIndex(pair => pair.bId === correctAnswerInMatchedPairs.bId && pair.bWord !== "");
//             if (incorrectIndex !== -1) {
//                 const incorrectBWord = updatedPairs[incorrectIndex].bWord;

//                 // Clear the incorrect word from the original place
//                 updatedPairs[incorrectIndex] = {
//                     ...updatedPairs[incorrectIndex],
//                     bWord: "",  // Clear the incorrect word
//                     bId: ""     // Clear the bId as well
//                 };

//                 // Add the incorrect word back to bGroup (but avoid adding correct answer)
//                 if (incorrectBWord && incorrectBWord !== correctAnswerInMatchedPairs.bWord) {
//                     setBGroup(prevBGroup => [...prevBGroup, { bWord: incorrectBWord, bId: matchedPairs[incorrectIndex].bId }]);
//                 }
//             }

//             // Update matchedPairs with the correct word in the right place
//             setMatchedPairs(updatedPairs);

//             // Return the current incorrect word in nextIndex to bGroup (but avoid adding correct answer)
//             if (currentBWord && currentBWord !== correctAnswerInMatchedPairs.bWord) {
//                 setBGroup(prevBGroup => [...prevBGroup, { bWord: currentBWord, bId: matchedPairs[nextIndex].bId }]);
//             }
//         }
//     };

//     const handleShowAnswer = () => {
//         const updatedPairs = matchedPairs.map(pair => {
//             const correctAnswerInBGroup = bGroup.find(b => b.bId === pair.aId)
//             const correctAnswerInMatchedPairs = matchedPairs.find(p => p.bId === pair.aId && p.bWord !== "");

//             if (correctAnswerInBGroup) {
//                 return {
//                     ...pair,
//                     bWord: correctAnswerInBGroup.bWord,
//                     bId: correctAnswerInBGroup.bId
//                 };
//             } else if (correctAnswerInMatchedPairs) {
//                 return {
//                     ...pair,
//                     bWord: correctAnswerInMatchedPairs.bWord,
//                     bId: correctAnswerInMatchedPairs.bId
//                 };
//             }
//             return pair; // If no change, return the pair as is
//         });

//         // Clear the bGroup since all answers are revealed
//         setMatchedPairs(updatedPairs);
//         setBGroup([]);
//     };

//     const handleSubmit = async () => {
//         setChecked(true);
//         setIsSubmitted(true)
//         const correctAnswers = matchedPairs.filter(pair => pair.aId === pair.bId).length;
//         const totalAnswers = matchedPairs.length;
//         const percentageCorrect = `${((correctAnswers / totalAnswers) * 100).toFixed(1)}%`
//         sendHomework(percentageCorrect, task, { matchedPairs, bGroup }, currentUser)
//         setTimeout(() => {
//             setCoinAnimationReady(true)
//     }   , 1000);        
//     }

//     //TEST LOGIC

    // useEffect(() => {
    //     if (currentLesson?.isTest && lessonPlanParts[currentTaskIndex].taskId === task.taskId && !checkingResult) {
    //         const correctMarks = matchedPairs.filter(pair => pair.aId === pair.bId).length;
    //         const possibleMarks = matchedPairs.length;
    //         const submit = { matchedPairs, bGroup }
    //         // const submit = matchedPairs;
    //         const taskTitle = task.taskTitle;
    //         const skillCategory = task.skillCategory
    //         const taskOrder = task.taskOrder

    //         if (updateTaskProgress && taskTitle) {
    //             // updateTaskProgress(taskId, { submit, correctMarks, possibleMarks, taskTitle, taskInfo: {bGroup}});
    //             updateTaskProgress(taskId, { submit, correctMarks, possibleMarks, taskTitle, skillCategory, taskOrder });
    //         }
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [matchedPairs])

//     return (
//         <div className={styles.match}>
//             <div className={classNames(styles.bGroup, {[styles.bGroupFullscreen] : isFullscreen})}>
//                 {bGroup.map((b, index) => (
//                     <div
//                         className={classNames('global-task-word', styles.bGroupWord, {
//                             [styles.wordFaded] : bSelected && bSelected.bId !== b.bId,
//                             [styles.wordSelected] : bSelected && bSelected.bId === b.bId,
//                             [styles.wordFullscreen] : isFullscreen
//                         })}
//                         key={index}
//                         onClick={() => handleBClick(b)}
//                     >
//                         {b.bWord}
//                     </div>
//                 ))}
//             </div>
//             <div className={classNames({[styles.row]: !displayVertically, [styles.rowVertical]: displayVertically}, {[styles.rowFullscreen] : isFullscreen})}>
//                 {matchedPairs.map((pair, index) => {
//                     // Find the correct answer from bGroup based on the aId
//                     const correctFromPairs = matchedPairs.find(p => p.bId === pair.aId);

//                     // Step 2: Fallback to bGroup if not found
//                     const correctFromGroup = bGroup.find(b => b.bId === pair.aId);
                
//                     // Final fallback-safe correct answer
//                     const correctBWord = correctFromPairs?.bWord || correctFromGroup?.bWord || '';

//                     return (
//                         <div key={index} className={classNames({[styles.pairHorizontal]: !displayVertically, [styles.pairVertical]: displayVertically}, {[styles.pairHorizontalFullscreen] : isFullscreen})}>
//                             <div className={classNames({[styles.pairAgroup]: !displayVertically, [styles.pairAgroupVertical]: displayVertically}, {[styles.pairAgroupFullscreen] : isFullscreen})}>
//                                 {pair.image && <img className={styles.image} src={fetchedImages[pair.image] || undefined} alt={pair.aWord} />}
//                                 <span>{pair.aWord}</span>
//                             </div>
//                             <div className={classNames({[styles.box]: !displayVertically, [styles.boxVertical]: displayVertically}, {
//                                 [styles.boxFull] : pair.bWord !== '',
//                                 [styles.boxMatching] : isMatching,
//                                 [styles.boxFullscreen] : isFullscreen,
//                                 })}
//                                 onClick={() => {
//                                 handleBoxClick(index);
//                                 if (pair.bWord) {
//                                     handleBClick({ bWord: pair.bWord, bId: pair.bId });
//                                 }
//                             }}
//                             style={{ width: `${bWordWidthCh}em` }}
//                             >
//                                 {pair.bWord || ''}
//                             </div>
//                             <div className={styles.answerContainer}>
//                                 {checked && pair.aId === pair.bId && <img className="answer-icon" src={correctIcon} alt="Correct" />}
//                                 {checked && pair.aId !== pair.bId && <img className="answer-icon" src={incorrectIcon} alt="Incorrect" />} 
//                             </div>
//                             {checked && pair.aId !== pair.bId && checkingResult && correctBWord && (
//                                 <span className="correct-answer">{correctBWord}</span>
//                             )}
//                         </div>
//                     );
//                 })}
//             </div>
//             <div className="message-container">
//                 {errMsg && <div className="error-message">{errMsg}</div>}
//             </div>
//             <Taskbar
//                 isFullscreen={isFullscreen}
//                 isSubmitted={isSubmitted}
//                 handleShowAnswer={handleShowAnswer}
//                 handleShowSingleAnswer={handleShowSingleAnswer}
//                 handleSubmit={handleSubmit}
//                 handleClear={handleClear}
//             />
//             {(coinAnimationData && coinAnimationData.newCoins && coinAnimationReady && !coinAnimationFinished) ? (
//                 <div className="coin-overlay">
//                     <CoinAnimation
//                         currentCoins={coinAnimationData.currentCoins}
//                         coinsToAward={coinAnimationData.newCoins}
//                         setCoinAnimationFinished={setCoinAnimationFinished}
//                     />
//                 </div>
//             ) : null}
//         </div>
//     );
// }

// export default Match

interface Pair {
    matchId: number;
    A: string;
    B: string;
    image?: string;
    color?: string;
}

interface MatchProps {
    task: MatchTask;
    isFullscreen?: boolean;
}

// No red / pink / magenta – students read those as "wrong".
const distinctColors = [
    "#3CB44B", // Green
    "#4363D8", // Blue
    "#F58231", // Orange
    "#911EB4", // Purple
    "#469990", // Teal
    "#42D4F4", // Cyan
    "#F5C211", // Gold
    "#9A6324", // Brown
    "#BCF60C", // Lime / Bright Green
    "#000075", // Navy
    "#008080", // Dark Cyan
    "#808000", // Olive
    "#DCBEFF", // Lavender
    "#AAFFC3", // Mint
    "#A9A9A9", // Dark Gray
];

function shuffle<T>(array: T[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export const Match: React.FC<MatchProps> = ({ task, isFullscreen }) => {
    const [pairs, setPairs] = useState<Pair[]>([]);
    const [bPairs, setBPairs] = useState<Pair[]>([]);
    const [selectedA, setSelectedA] = useState<number | null>(null);
    const [matches, setMatches] = useState<Map<number, number>>(new Map());
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [fetchedImages, setFetchedImages] = useState<{ [key: string]: string | null }>({});
    const { sendHomework, coinAnimationData } = useSendHomework();
    const [coinAnimationFinished, setCoinAnimationFinished] = useState(false);
    const [coinAnimationReady, setCoinAnimationReady] = useState(false);
    const taskId = Number(task?.taskId)
    const { currentUser } = useContext(AuthContext);
    const { currentLesson, currentTaskIndex, checkingResult, studentId, currentTestAttempt, isLessonMode } = useContext(LessonContext);

    const {data: lessonData} = useLessonData(Number(currentLesson?.lessonId))
    const lessonPlanParts = lessonData?.lessonPlanParts || []

    const { data: testTasks } = useTestTasks(Number(currentLesson?.lessonId), Number(studentId), currentTestAttempt, checkingResult);
    const { testProgress, updateTaskProgress } = useTestProgress(Boolean(currentLesson?.isTest), Number(currentLesson?.lessonId), currentTestAttempt);

  // LOADING FUNCTIONS
  
    useEffect(() => {
        const fetchAllImages = async () => {
            if (!pairs || pairs.length === 0) return;

            const newFetchedImages = { ...fetchedImages };

            for (const pair of pairs) {
                if (pair.image && !newFetchedImages[pair.image]) {
                    const imageUrl = await fetchImage(pair.image);
                    newFetchedImages[pair.image] = imageUrl;
                }
            }

            setFetchedImages(newFetchedImages);
        };

        fetchAllImages();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pairs]);

  // Initialize pairs with colors
  useEffect(() => {
    if (!task.taskContent?.pairs) return;

    const initializedPairs = task.taskContent.pairs.map((pair, index) => ({
      matchId: index,
      A: pair.A ?? "",
      B: pair.B ?? "",
      image: pair.image,
      color: distinctColors[index], // unique pastel color
    }));

    setPairs(initializedPairs);
    setBPairs(shuffle([...initializedPairs]));

    //test progress
    if (currentLesson?.isTest && testProgress && testProgress[Number(task.taskId)] && testProgress[Number(task.taskId)].submit) {
      const progressData = testProgress[Number(task.taskId)].submit as {
        matches: { aIndex: number; bIndex: number }[];
        bPairs: typeof bPairs;
      };

      // progressData now contains:
      // { matches: [{ aIndex, bIndex }], bPairs: [...] }
    
      if (progressData.matches && progressData.bPairs) {
        setBPairs(progressData.bPairs);
    
        // Convert array of objects back to Map
        setMatches(
          new Map(progressData.matches.map(({ aIndex, bIndex }) => [aIndex, bIndex]))
        );
      }
    }

    if (checkingResult) {

      setIsSubmitted(true)

      if (task.submit) {
        const parsed =
        typeof task.submit === "string"
          ? JSON.parse(task.submit)
          : task.submit;
  
        const { matches: savedMatches, bPairs: savedBPairs } = parsed;
        setBPairs(savedBPairs);
        const restoredMatches = new Map<number, number>();
        savedMatches.forEach(({ aIndex, bIndex }: { aIndex: number; bIndex: number }) => {
          restoredMatches.set(aIndex, bIndex);
        });
        setMatches(restoredMatches);
        
  
      } else if (testTasks) {
        const testTask = testTasks.find((t) => t.taskId === Number(task.taskId));
        if (!testTask?.submit) return;

        const parsed = typeof testTask.submit === "string"
          ? JSON.parse(testTask.submit)
          : testTask.submit;

        const { matches: savedMatches, bPairs: savedBPairs } = parsed;
        setBPairs(savedBPairs);
        const restoredMatches = new Map<number, number>();

        savedMatches.forEach(
          ({ aIndex, bIndex }: { aIndex: number; bIndex: number }) => {
            restoredMatches.set(aIndex, bIndex);
          }
        );

        setMatches(restoredMatches)
      }

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [task.taskContent?.pairs]);

  const handleAClick = (index: number) => setSelectedA(index);

  const handleBClick = (index: number) => {
    if (selectedA === null) return;

    const newMatches = new Map(matches);

    // Remove any previous connection to this B or from selected A
    newMatches.forEach((b, a) => {
      if (b === index || a === selectedA) newMatches.delete(a);
    });

    newMatches.set(selectedA, index);
    setMatches(newMatches);
    setSelectedA(null);
  };

  const isCorrect = (aIndex: number, bIndex: number) =>
    pairs[aIndex].matchId === bPairs[bIndex].matchId;

  const handleSubmit = async () => {
    setIsSubmitted(true)
    const correctAnswers = Array.from(matches.entries()).filter(
      ([aIndex, bIndex]) =>
        pairs[aIndex].matchId === bPairs[bIndex].matchId
    ).length;

    const matchesArray = Array.from(matches.entries()).map(
      ([aIndex, bIndex]) => ({ aIndex, bIndex })
    );

    const totalAnswers = pairs.length;
    const percentageCorrect = `${((correctAnswers / totalAnswers) * 100).toFixed(0)}%`

    sendHomework(percentageCorrect, task, { matches: matchesArray, bPairs }, currentUser)
    setTimeout(() => {
        setCoinAnimationReady(true)
    }, 1000);        
    if (task.isHomework && currentUser?.mode === 'student') {
      clearHomeworkState(taskId);
    }
}

  const showNextAnswer = () => {
    const newMatches = new Map(matches);
  
    for (let a = 0; a < pairs.length; a++) {
      if (!newMatches.has(a)) {
        const bIndex = bPairs.findIndex(
          (b) => b.matchId === pairs[a].matchId
        );
        if (bIndex !== -1) {
          newMatches.set(a, bIndex);
          setMatches(newMatches);
        }
        return;
      }
    }
  };

  const showAllAnswers = () => {
    const all = new Map<number, number>();
  
    pairs.forEach((aPair, aIndex) => {
      const bIndex = bPairs.findIndex(
        (bPair) => bPair.matchId === aPair.matchId
      );
  
      if (bIndex !== -1) {
        all.set(aIndex, bIndex);
      }
    });
  
    setMatches(all);
  };

  const reset = () => {
    setMatches(new Map());
    setSelectedA(null);
    setIsSubmitted(false);
  };

  const hasImages = pairs.some(pair => !!pair.image);
  const displayHorizontally = task.taskSettings?.displayHorizontally;

  useEffect(() => {
    if (currentLesson?.isTest && lessonPlanParts[currentTaskIndex].taskId === task.taskId && !checkingResult && matches.size > 0 && bPairs.length > 0) {
      // Count correct answers
      const correctMarks = Array.from(matches.entries()).filter(
        ([aIndex, bIndex]) => pairs[aIndex].matchId === bPairs[bIndex].matchId
      ).length;
  
      const possibleMarks = pairs.length;
  
      // Prepare the data to store
      const submit = {
        matches: Array.from(matches.entries()).map(([aIndex, bIndex]) => ({
          aIndex,
          bIndex,
        })),
        bPairs, // include bPairs so it can be reloaded
      };
  
      const taskTitle = task.taskTitle;
      const skillCategory = task.skillCategory;
      const taskOrder = task.taskOrder;
      const taskType = task.taskType;
  
      if (updateTaskProgress && taskTitle) {
        updateTaskProgress(taskId, {
          submit,
          correctMarks,
          possibleMarks,
          taskTitle,
          taskType,
          skillCategory,
          taskOrder,
        });
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matches, bPairs]);

  //Restore Homework data
  useEffect(() => {
    const saved = loadHomeworkState(taskId) as { matches: { aIndex: number; bIndex: number }[]; bPairs: Pair[] } | null;
    if (!saved || checkingResult) return;
    if (saved.matches && saved.bPairs) {
      setBPairs(saved.bPairs);
      setMatches(new Map(saved.matches.map(({ aIndex, bIndex }) => [aIndex, bIndex])));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);

  //RESTORE LOST HOMEWORK
  useEffect(() => {
    if (task.isHomework && currentUser?.mode === 'student' && isLessonMode && !isSubmitted && !checkingResult && bPairs.length > 0) {
      const matchesArray = Array.from(matches.entries()).map(([aIndex, bIndex]) => ({ aIndex, bIndex }));
      saveHomeworkState(taskId, { matches: matchesArray, bPairs });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matches, bPairs]);

  return (
    <div className={styles.match}>
      <div className={classNames(styles.container, {
        [styles.containerFullscreen] : isFullscreen,
      })}>
        <div className={classNames(styles.columns, {[styles.columnsHorizontal]: displayHorizontally})}>
          {/* Column A */}
          <div className={`${styles.column} ${hasImages ? styles.imageGrid : ""}`}>
            {pairs.map((pair, i) => {
              const isMatched = matches.has(i);

              return (
                <div
                  key={i}
                  className={classNames(styles.item, {
                    [styles.active]: selectedA === i,
                    [styles.itemFullscreen]: isFullscreen,
                  })}
                  onClick={() => handleAClick(i)}
                  style={{
                    borderColor: pair.color,
                    backgroundColor: isMatched ? `${pair.color}33` : "transparent",
                  }}
                >
                  {pair.image && (
                    <div className={styles.imageWrapper}>
                      <img src={fetchedImages[pair.image] || undefined} alt={pair.A} />
                    </div>
                  )}
                  {pair.A && <div>{pair.A}</div>}
                </div>
              );
            })}
          </div>

          {/* Column B */}
          <div className={styles.bcolumn}>
            {bPairs.map((pair, i) => {
              let matchedA: number | undefined;
              matches.forEach((b, a) => {
                if (b === i) matchedA = a;
              });

              const correct = matchedA !== undefined && isCorrect(matchedA, i);
              const bColor = matchedA !== undefined ? pairs[matchedA].color : undefined;

              return (
              <div key={i} className={styles.bContainer}>
                  <div
                      className={classNames(styles.item, {
                        [styles.itemFullscreen]: isFullscreen,
                      })}
                      onClick={() => handleBClick(i)}
                      style={{
                      borderColor: bColor,
                      backgroundColor: bColor ? `${bColor}33` : undefined, // semi-transparent
                      }}
                  >
                      {pair.B}
                  </div>
                      <div className={styles.iconContainer}>
                          {isSubmitted && matchedA !== undefined && (
                              <img
                                  src={correct ? correctIcon : incorrectIcon}
                                  className={styles.icon}
                                  alt="icon"
                              />
                          )}
                      </div>
                      {checkingResult && isSubmitted && matchedA !== undefined && !correct && (
                          <span className="correct-answer">{pairs[matchedA].B}</span>
                      )}
                  </div>
                      
                  
                  );
              })}
              </div>
        </div>
        
      </div>
      <Taskbar
          isFullscreen={isFullscreen}
          isSubmitted={isSubmitted}
          handleShowAnswer={showAllAnswers}
          handleShowSingleAnswer={showNextAnswer}
          handleSubmit={handleSubmit}
          handleClear={reset}
      />
      {(coinAnimationData && coinAnimationData.newCoins && coinAnimationReady && !coinAnimationFinished) ? (
          <div className="coin-overlay">
              <CoinAnimation
                  currentCoins={coinAnimationData.currentCoins}
                  coinsToAward={coinAnimationData.newCoins}
                  setCoinAnimationFinished={setCoinAnimationFinished}
              />
          </div>
      ) : null}
    </div>
  );
};

export default Match;
    
